import { CloseOutlined, DeleteOutlined, PlusOutlined } from "@ant-design/icons"
import { Button, ColorPicker, Form, Input, Modal } from "antd"
import '../CampaignSendsNotifications.scss'
import { ChangeEvent, useEffect, useRef, useState } from "react"
import { useForm } from "antd/es/form/Form"
import { FormInstance, FormProps } from "antd/lib"
import { addListTarget } from "../../../../api/target/targetApi"
import useToast from "../../../../hook/useToast"

interface ModalProps {
    isOpen: boolean
    onSubmitFormModal: (iSsuccess: boolean, errorMessage?: string) => void
    closeModal: (e: boolean) => void
}
const ModalAddTarget: React.FC<ModalProps> = ({
    isOpen, onSubmitFormModal, closeModal,
}) => {


    const [form] = useForm();
    const pushToast = useToast();

    const inputRef = useRef<FormInstance>(null);
    const imgRef = useRef<HTMLInputElement>(null);

    const [uploadedFile, setUploadedFile] = useState<File | null>(null);




    const handleUploadClick = (
        event: React.MouseEvent
    ) => {
        event.preventDefault();
        imgRef.current?.click();
    };

    const handleFileChange = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        const file = event.target.files?.[0];

        if (!file) return;

        if (file.type !== 'image/png') {
            pushToast(
                'Chỉ cho phép tải lên file PNG',
                'warning'
            );

            // Xóa file khỏi input
            event.target.value = '';

            // Xóa preview
            setUploadedFile(null);

            // QUAN TRỌNG: xóa file SVG khỏi Ant Form
            form.setFieldValue('image', undefined);

            return;
        }

        setUploadedFile(file);

        // QUAN TRỌNG
        form.setFieldValue('image', file);
    };

    const submitForm = () => {
        if (inputRef.current) {
            inputRef.current.submit();
        }
    };


    const onFinish: FormProps["onFinish"] = async (values) => {
        const { title, image, colorBorder, bgColor, colorText } = values;

        const colorBorderTmp = colorBorder?.toHexString?.().replace('#', '') ?? 'B4B4B4'
        const bgColorTmp = bgColor?.toHexString?.().replace('#', '') ?? 'ffffff'
        const colorTextTmp = colorText?.toHexString?.().replace('#', '') ?? '1677ff'

        const result = await addListTarget(title, image, colorBorderTmp, bgColorTmp, colorTextTmp)

        if (result?.status) {
            onSubmitFormModal?.(true, result?.message)
        } else {
            onSubmitFormModal?.(false, result?.message)
        }
    };

    useEffect(() => {
        if (isOpen) {
            // form.setFieldValue("color", '#ffffff');
        } else {
            form.resetFields()
            setUploadedFile(null)
            if (imgRef.current) {
                imgRef.current.value = "";
            }
        }
    }, [isOpen])


    return (

        <Form
            form={form}
            ref={inputRef}
            onFinish={onFinish}
            initialValues={{ remember: true }}
        >
            <Modal
                title={<div className="bg-FCFCFD d-flex justify-betweeen align-center py-4 px-6 w-full border-b-F0F0F0 rounded-2 overflow-hidden">
                    <span className="text-base text-344054 fw-500 font-medium">Thêm mới mục tiêu</span>
                    <CloseOutlined className="text-base text-8B8B8B" onClick={() => closeModal(false)} />
                </div>}
                open={isOpen}
                onCancel={() => closeModal(false)}
                centered
                className="w-modal modal-content-warning ant-modal-size"
                closeIcon={false}
                footer={
                    <div className="bg-FCFCFD d-flex justify-betweeen align-center py-2 px-6 w-full border-t-F0F0F0">
                        <span className="text-sm text-98A2B3 cursor-pointer"
                            onClick={() => closeModal(false)}
                        >Huỷ</span>
                        <button
                            className="text-white text-sm bg-096DD9 border-none shadow-btn-save rounded-2 h-8 px-15-px"
                            onClick={submitForm}>
                            Lưu
                        </button>
                    </div>}
            >
                <div className="p-6 d-flex flex-column gap-18-px">

                    <div className="d-flex flex-column gap-1">
                        <div className="d-flex flex-column   overflow-hidden">
                            <div className="border-F2F4F7 rounded-2-px w-104-px h-104-px bg-F9FAFB d-flex align-center justify-center relative"
                            >
                                {uploadedFile ? (
                                    <img
                                        src={URL.createObjectURL(uploadedFile)}
                                        alt="Uploaded"
                                        className="w-104-px  rounded-3 cursor-pointer"
                                        onClick={() => (imgRef as any).current.click()}
                                    />
                                ) : (
                                    <div
                                        className="d-flex flex-column align-center gap-2 cursor-pointer"
                                        onClick={handleUploadClick}
                                    >
                                        <PlusOutlined className="text-sm text-252626" />
                                        <span className="text-sm text-98A2B3 text-center">
                                            Tải lên <br /> Logo
                                        </span>
                                    </div>
                                )}


                            </div>
                            <Form.Item
                                className='custom-err-modal'
                                name="image"
                                rules={[{ required: true, message: "Vui lòng tải lên logo!" }]}
                                valuePropName="file"
                                getValueFromEvent={(e) => {
                                    if (Array.isArray(e)) return e;
                                    return e?.target?.files?.[0];
                                }}
                            >
                                <input
                                    type="file"
                                    accept="image/*"
                                    style={{ display: "none" }}
                                    ref={imgRef}
                                    onChange={handleFileChange}
                                />
                            </Form.Item>
                        </div>
                        <div className="d-flex flex-column gap-1">
                            <div className="d-flex flex-column gap-1">
                                <Form.Item
                                    label={<span className="">Tên mục tiêu<span className="pl-1" style={{ color: 'red' }}>*</span></span>}
                                    layout="vertical"
                                    name="title"
                                    rules={[{ required: true, message: 'Nhập tên mục tiêu!' }]}
                                    className="m-none-form-item text-explan text-label"
                                >
                                    <Input
                                        placeholder="Tên mục tiêu"
                                        className="bg-FCFCFD border-F2F4F7 text-sm rounded-2  font-regular  input-custom  h-8"
                                    />
                                </Form.Item>
                            </div>
                        </div>
                        <div className="d-flex flex-column gap-1">
                            <div className="d-flex flex-column gap-1">
                                <Form.Item
                                    label={<span className="">Chọn màu viền</span>}
                                    layout="vertical"
                                    name="colorBorder"
                                    className="m-none-form-item text-explan text-label"
                                >
                                    <ColorPicker defaultValue="#1677ff" showText allowClear format="hex" />
                                </Form.Item>
                            </div>
                        </div>
                        <div className="d-flex flex-column gap-1">
                            <div className="d-flex flex-column gap-1">
                                <Form.Item
                                    label={<span className="">Chọn màu nền</span>}
                                    layout="vertical"
                                    name="bgColor"
                                    className="m-none-form-item text-explan text-label"
                                >
                                    <ColorPicker defaultValue="#ffffff" showText allowClear format='hex' />
                                </Form.Item>
                            </div>
                        </div>
                        <div className="d-flex flex-column gap-1">
                            <div className="d-flex flex-column gap-1">
                                <Form.Item
                                    label={<span className="">Chọn màu chữ</span>}
                                    layout="vertical"
                                    name="colorText"
                                    className="m-none-form-item text-explan text-label"
                                >
                                    <ColorPicker defaultValue="#B4B4B4" showText allowClear format='hex' />
                                </Form.Item>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </Form>
    )
}
export default ModalAddTarget
